export default {
  heading: 'InterVariable, -apple-system, system-ui, sans-serif',
  body: 'InterVariable, -apple-system, system-ui, sans-serif',
}
